var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Carousel',{attrs:{"autoplay":true,"per-page":3,"loop":true,"navigation-enabled":false,"pagination-enabled":false,"scroll-per-page":false}},_vm._l((_vm.logos),function(logo,k){return _c('Slide',{key:k},[_c('img',{staticClass:"opacity-5",attrs:{"src":logo}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }